import { render, staticRenderFns } from "./ReadFile.vue?vue&type=template&id=df4c9eea&"
import script from "./ReadFile.js?vue&type=script&lang=js&"
export * from "./ReadFile.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports